import Vue from "vue";
import VueRouter from "vue-router";
import LoginView from "@/views/LoginView.vue";
import HomeView from "../views/HomeView.vue";
import { adminApi } from "@/api";
import store from "@/store";
import TradeListPage from "@/pages/TradeListPage.vue";
import TraderListPage from "@/pages/TraderListPage.vue";
import BankAccountList from "@/pages/BankAccountListPage.vue";
import SenderBankAccountList from "@/pages/SenderBankAccountList.vue";
import DashboardPage from "@/pages/DashboardPage.vue";

Vue.use(VueRouter);

const routes = [
    {
        path: "/login",
        name: "login",
        component: LoginView,
    },
    {
        path: "/",
        name: "home",
        component: HomeView,
        redirect: "/trades",
        children: [
            {
                path: "/dashboard",
                name: "Dashboard",
                component: DashboardPage,
                beforeEnter: function (to, from, next) {
                    verifyAdminLogin(next);
                },
            },
            {
                path: "/trades",
                name: "Trade List",
                component: TradeListPage,
                beforeEnter: function (to, from, next) {
                    verifyAdminLogin(next);
                },
            },
            {
                path: "/traders",
                name: "Trader List",
                component: TraderListPage,
                beforeEnter: function (to, from, next) {
                    verifyAdminLogin(next);
                },
            },
            {
                path: "/bank-accounts",
                name: "Bank Accounts",
                component: BankAccountList,
                beforeEnter: function (to, from, next) {
                    verifyAdminLogin(next);
                },
            },
            {
                path: "/sender-bank-accounts",
                name: "Sender Bank Accounts",
                component: SenderBankAccountList,
                beforeEnter: function (to, from, next) {
                    verifyAdminLogin(next);
                },
            },
        ],
    },
];

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes,
});

const verifyAdminLogin = async function (next) {
    let token;
    if (store.state.currentUser) {
        return next();
    } else {
        token = localStorage.getItem("token");
    }

    if (!token) {
        next("/login");
    } else {
        try {
            const data = await adminApi.getAdminInfo();
            store.commit("setCurrentUser", data);
            return next();
        } catch (error) {
            console.log(error);
            next("/login");
        }
    }
};

export default router;
